import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_address_book_contact_record_hdr_RowClass} from '../../../dbschema/bl_crm_address_book_contact_record_hdr.model'

export class CrmAddressBookContactRecordHdrContainerModel extends BaseContainerModel {
    bl_crm_address_book_contact_record_hdr: bl_crm_address_book_contact_record_hdr_RowClass = new bl_crm_address_book_contact_record_hdr_RowClass()
  }
